import { useMemo } from 'react';

import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { Box, Flex } from '@atlaskit/primitives';

import { useLoggedInUser } from '@/utils/logged-in-user-provider';

import { shouldAutoSelectLoomOnboardingWorkUseCase } from '../utilities/should-auto-select-loom-onboarding-work-use-case';

import type { OnboardingStepProps } from '../utilities/types';

export const useShouldAutoSelectUseCasePlan = (): boolean => {
	const { email = '' } = useLoggedInUser();

	return useMemo(() => shouldAutoSelectLoomOnboardingWorkUseCase(email), [email]);
};

export const PersonaUseCaseStep = ({ onContinue }: OnboardingStepProps) => {
	return (
		<Box>
			<Heading size="large">Who are you?</Heading>
			<Flex>
				<Button appearance="primary" onClick={onContinue}>
					Continue
				</Button>
			</Flex>
		</Box>
	);
};
